module.exports = __webpack_public_path__ + "static/media/005.25da8846.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/gallery/005.jpg
// module id = 549
// module chunks = 0